import { render, staticRenderFns } from "./AppBuilder.vue?vue&type=template&id=08c07569&"
import script from "./AppBuilder.vue?vue&type=script&lang=js&"
export * from "./AppBuilder.vue?vue&type=script&lang=js&"
import style0 from "./AppBuilder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports